export const projectsData = [
  {
    id: "villa-moderna",
    img: "https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=1400&q=80&fit=crop",
    title_IT: "Villa Moderna – Milano", title_EN: "Modern Villa – Milan",
    desc_IT: "Progettazione completa degli arredi per una villa di lusso nel cuore di Milano. Dal soggiorno alla camera da letto, ogni pezzo è stato realizzato su misura in rovere massello con finiture in ottone.",
    desc_EN: "Complete furniture design for a luxury villa in the heart of Milan. From the living room to the bedroom, every piece was custom-made in solid oak with brass finishes.",
    materials_IT: ["Rovere Massello", "Ottone", "Pelle Naturale", "Marmo Nero"],
    materials_EN: ["Solid Oak", "Brass", "Natural Leather", "Black Marble"],
  },
  {
    id: "loft-industriale",
    img: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=1400&q=80&fit=crop",
    title_IT: "Loft Industriale – Torino", title_EN: "Industrial Loft – Turin",
    desc_IT: "Riqualificazione di un loft industriale con arredi che fondono metallo e legno recuperato. I mobili conservano l'estetica raw dello spazio valorizzandola con elementi artigianali di pregio.",
    desc_EN: "Redevelopment of an industrial loft with furniture blending metal and reclaimed wood. The pieces preserve the raw aesthetic of the space while enhancing it with quality artisanal elements.",
    materials_IT: ["Legno Recuperato", "Ferro Battuto", "Vetro Temperato"],
    materials_EN: ["Reclaimed Wood", "Wrought Iron", "Tempered Glass"],
  },
  {
    id: "attico-venezia",
    img: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1400&q=80&fit=crop",
    title_IT: "Attico – Venezia", title_EN: "Penthouse – Venice",
    desc_IT: "Arredamento di un attico veneziano con vista sul Canal Grande. Lo stile riprende la tradizione veneziana con intarsi in legno pregiato e tessuti damasco.",
    desc_EN: "Furnishing of a Venetian penthouse overlooking the Grand Canal. The style draws on Venetian tradition with precious wood inlays and damask fabrics.",
    materials_IT: ["Noce Canaletto", "Velluto", "Oro Zecchino", "Damasco"],
    materials_EN: ["Canaletto Walnut", "Velvet", "Fine Gold", "Damask"],
  },
  {
    id: "casale-toscano",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=1400&q=80&fit=crop",
    title_IT: "Casale Toscano", title_EN: "Tuscan Farmhouse",
    desc_IT: "Restauro e arredamento di un casale toscano del '700. Ogni mobile è stato progettato per rispettare l'architettura originale mantenendo comfort e funzionalità contemporanei.",
    desc_EN: "Restoration and furnishing of an 18th-century Tuscan farmhouse. Each piece was designed to respect the original architecture while maintaining contemporary comfort and functionality.",
    materials_IT: ["Castagno", "Cotto", "Ferro Forgiato", "Lino Grezzo"],
    materials_EN: ["Chestnut", "Terracotta", "Forged Iron", "Raw Linen"],
  },
  {
    id: "studio-architettura",
    img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1400&q=80&fit=crop",
    title_IT: "Studio di Architettura – Roma", title_EN: "Architecture Studio – Rome",
    desc_IT: "Arredamento completo di uno studio professionale nel centro di Roma. Scrivanie su misura, librerie a parete e sala riunioni in noce nero con dettagli in acciaio satinato.",
    desc_EN: "Complete furnishing of a professional studio in central Rome. Custom desks, wall-to-wall bookshelves and meeting room in black walnut with satin steel details.",
    materials_IT: ["Noce Nero", "Acciaio Satinato", "Vetro Acidato"],
    materials_EN: ["Black Walnut", "Satin Steel", "Acid-Etched Glass"],
  },
  {
    id: "boutique-hotel",
    img: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=900&q=80&fit=crop",
    imgLarge: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1400&q=80&fit=crop",
    title_IT: "Boutique Hotel – Firenze", title_EN: "Boutique Hotel – Florence",
    desc_IT: "Fornitura di arredi per 24 camere di un boutique hotel nel centro storico di Firenze. Ogni camera racconta una storia diversa attraverso i suoi mobili, unendo tradizione e modernità.",
    desc_EN: "Furniture supply for 24 rooms of a boutique hotel in historic Florence. Each room tells a different story through its furniture, blending tradition and modernity.",
    materials_IT: ["Ciliegio", "Velluto Smeraldo", "Bronzo", "Cartapesta"],
    materials_EN: ["Cherry Wood", "Emerald Velvet", "Bronze", "Papier-Mâché"],
  },
];
